import { IWireDisbursementFormData } from 'types/order/escrow/wires/IWireDisbursementFormData';
import { ICheckDisbursementFormData } from 'types/order/escrow/checks/ICheckDisbursementFormData';
import { IACHDisbursementFormData } from './achDisbursements/IACHDisbursementFormData';
import { IInternalTransferDisbursementFormData } from './internalTransferDisbursements/IInternalTransferDisbursementFormData';
import { eDisbursementType } from './eDisbursementType';

export type IDisbursementFormData =
  | IWireDisbursementFormData
  | ICheckDisbursementFormData
  | IACHDisbursementFormData
  | IInternalTransferDisbursementFormData;

export const isCheckDisbursementFormData = (data: IDisbursementFormData): data is ICheckDisbursementFormData => {
  return data.type === eDisbursementType.Check;
};

export const isACHDisbursementFormData = (data: IDisbursementFormData): data is IACHDisbursementFormData => {
  return data.type === eDisbursementType.ACH;
};

export const isWireDisbursementFormData = (data: IDisbursementFormData): data is IWireDisbursementFormData => {
  return data.type === eDisbursementType.Wire;
};
